module.exports = __webpack_public_path__ + "media/images/rank_s-a03ce2c442337da4a7daff9c50e091c2.gif";